import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4 uppercase tracking-wide">
            关于我们
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-6">
            {aboutData.title}
          </h2>
          <div className="w-16 h-0.5 bg-primary-500 mx-auto mb-8"></div>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed">
            {aboutData.content}
          </p>
        </div>
      </div>
    </section>
  );
}